"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-8">
        <div className="h-6 w-16 bg-muted animate-pulse rounded-sm" />
        <div className="h-6 w-16 bg-muted animate-pulse rounded-sm" />
        <div className="h-6 w-16 bg-muted animate-pulse rounded-sm" />
      </div>;
  }
  const filteredItems = menuItems.filter(item => item.label !== "Terms   Conditions" && item.label !== "Terms & Conditions");
  const servicesItem = filteredItems.find(item => item.label === "Services");
  const blogItem = filteredItems.find(item => item.label === "Blog");
  const otherItems = filteredItems.filter(item => item.label !== "Services" && item.label !== "Blog");
  const reorderedItems = [...(servicesItem ? [servicesItem] : []), ...(blogItem ? [blogItem] : []), ...otherItems];
  return <>
      <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 hover:!bg-transparent focus:!bg-transparent transition-transform duration-150 hover:scale-105" aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6 text-[#B86A5A]" /> : <Menu className="size-6 text-[#B86A5A]" />}
      </button>

      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList className="gap-8">
          {reorderedItems.map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative text-sm font-medium tracking-wide hover:!bg-transparent focus:!bg-transparent transition-all duration-150 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-foreground after:transition-all after:duration-300 hover:after:w-full focus:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-background border-b shadow-soft">
          <nav className="flex flex-col py-4 px-6 gap-4">
            {reorderedItems.map(item => <Link key={item.id} to={item.href || "#"} onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wide py-2 hover:!bg-transparent focus:!bg-transparent transition-all duration-150">
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 left-0 right-0 z-50 bg-background border-b border-border transition-all duration-300 ${isScrolled ? "h-16 shadow-soft" : "h-24"}`}>
      <div className="container mx-auto px-6 h-full flex items-center justify-between">
        <Link to="/" className="transition-transform duration-150 hover:scale-105 focus:scale-105 hover:!bg-transparent focus:!bg-transparent">
          <img src="https://daring-lynx.10web.cloud/wp-content/uploads/2026/01/Black-Grey-Elegant-Typography-Monogram-Initials-Logo.png" alt="AB Studios" className="h-20" />
        </Link>

        <MenuProvider menu_id="4" className="flex items-center">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}